import React, { Component } from 'react';
import { Translate, I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import FIELDS from '../../data/fields';
import validators from '../../helpers/validator/formValidator';
import { createUser, updateAdminUser } from '../../app/store/actions/adminUsers';
import AccessProfilesAction from '../../app/store/actions/accessProfiles';

class AdminUsersFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      email: '',
      name: '',
      password: '',
      passwordConfirm: '',
      profileId: '',
      profileName: '',
      message: '',
      success: '',
      isLoading: false,
    };
  }

  async componentDidMount() {
    await this.props.getAccessProfiles('');    
    if (this.props.back.location.item) {
      await this.props.getAccessProfile(this.props.back.location.item.profileId);
      this.setAdminUserUpdate(this.props.back.location.item); 
      this.setState({
        profileId: this.props.profile && this.props.profile.id,
        profileName: this.props.profile && this.props.profile.description, 
      });          
    }
  }

  checkProfilesDescription = (profile) => {
    return (
      <option key={profile.id} value={profile.id}>
        {`${profile.id} - ${profile.description}`}
      </option>
    )
  }

  getAccessProfilesOptions = profiles => profiles.map(this.checkProfilesDescription)

  setAccessProfile = (profileId) => {
    this.setState({ profileId, message: '', success: '' });
  };

  sendAdminUserData = async () => {
    const {
      id, email, name, password, passwordConfirm, profileId,
    } = this.state;
    this.setState({
      isLoading: true,
    });
    const isUpdating = !!this.props.back.location.item;

    const formValidation = validators.adminUserFormValidator({
      email, name, password, passwordConfirm, isUpdating,
    });

    if (formValidation.isValid) {
      try {
        if (isUpdating) {
          await this.props.updateAdmin(id, {
            name, email, password, profileId,
          });
          this.setState({
            success: I18n.t('adminUserSuccessUpdate'),
            message: '',
            isLoading: false,
          });
        } else {
          await this.props.createAdminUser({ name, email, password, profileId });
          this.setState({
            success: I18n.t('adminUserSuccess'),
            message: '',
            isLoading: false,
          });
        }
      } catch (error) {
        this.setState({
          message: I18n.t('errorOcurred'),
          success: '',
          isLoading: false,
        });
      }
    } else {
      this.setState({
        message: formValidation.message,
        success: '',
        isLoading: false,
      });
    }
  }


  goBack = () => {
    this.props.back.goBack();
  };

  setAdminUserUpdate = (row) => {
    const { id, email, name } = row;
    this.setState({
      id,
      email,
      name,
    });
  }

  render() {
    const {
      email, name, message, success, password, isLoading, passwordConfirm, profileId,
    } = this.state;

    const { profiles } = this.props;

    return (
      <div className="form-main">
        <h2 className="header-form-client">
          <Translate value="adminUserRegister" />
        </h2>
        <form>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="name" /></p>
            <input
              type="text"
              onChange={e => this.setState({ name: e.target.value })}
              value={name}
              className="form-control"
              aria-describedby="name"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="email" /></p>
            <input
              type="text"
              onChange={e => this.setState({ email: e.target.value })}
              value={email}
              className="form-control"
              aria-describedby="email"
              placeholder=""
              maxLength={FIELDS.max}
            />
          </div>

          <div className="form-group">
            <p className="margin-bottom-2"><Translate value="profile" /></p>
            <select
              className="custom-select"
              onChange={e => this.setAccessProfile(e.target.value)}
              required
              value={profileId}
            >
              <option value={''}>{''}</option>             
              {profiles && profiles.rows && this.getAccessProfilesOptions(profiles.rows)}
            </select>
            <div className="invalid-feedback"><Translate value="selectCategory" /></div>
          </div>

          <p className="margin-bottom-2"><Translate value="password" /></p>

          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder={I18n.t('password')}
              onChange={e => this.setState({
                password: e.target.value,
                message: '',
                success: '',
              })}
              value={password}
              maxLength={FIELDS.password_max}
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              className="form-control"
              placeholder={I18n.t('confirmPassword')}
              onChange={e => this.setState({
                passwordConfirm: e.target.value,
                message: '',
                success: '',
              })}
              value={passwordConfirm}
              maxLength={FIELDS.password_max}
            />
          </div>

          {success && <p className="color-green margin-top-10">{success}</p>}
          {message && <p className="color-red margin-top-10">{message}</p>}

          <div className="row margin-left-0 margin-top-10">
            <button
              type="button"
              onClick={() => this.goBack()}
              className="btn btn-warning margin-right-15"
            >
              <Translate value="return" />
            </button>


            <button
              type="button"
              className="btn btn-dark"
              onClick={() => this.sendAdminUserData()}
              disabled={isLoading}
            >
              {!this.props.back.location.item ? (<Translate value="save" />) : (<Translate value="update" />) }

            </button>


          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  createAdminUser: ({ name, email, password, profileId }) => dispatch(createUser({ name, email, password, profileId })),
  updateAdmin: (id, { name, email, password, profileId }) => dispatch(updateAdminUser(id, { name, email, password, profileId })),
  getAccessProfiles: (search) => { dispatch(AccessProfilesAction.getAccessProfilesSelect(search)); },
  getAccessProfile: id => dispatch(AccessProfilesAction.getAccessProfile(id)),
});

const mapStateToProps = state => ({
  profiles: state.accessProfiles.accessProfiles,
  profile: state.accessProfiles.accessProfile,  
});


export default connect(mapStateToProps, mapDispatchToProps)(AdminUsersFormComponent);
